import React, {useContext} from "react";

import NavigationMenuContext from "../NavigationMenuContext";

import {SubNavigationAside} from "./SubNavigationAside/SubNavigationAside";
import {Button} from "../../Button";

import {generateClassString as gcs} from "../../../lib/helper/generateClassString";

import * as styles from "./subNavigation.module.less";

export function SubNavigation({navMap}) {
    const {
        navigationReducer: {
            navState: {
                activeLayer: {id: activeId, name: activeLayerName, link, externalUrl}
            },
            dispatch
        },
        isMobile,
        setIsBackLink, isBackLink,
        getNavElement,
    } = useContext(NavigationMenuContext);

    const closeSubNav = () => {
        document.lastId = undefined;
        dispatch({type: "closeSubNav"});
    };

    const navelement = getNavElement(activeId);
    const newLocal = navelement?.subNavElements?.length > 0;

    return (
        <>
            <div className={gcs(styles.menus, [newLocal, styles.isVisible])}>
                <div className={styles.subNavWrapper}>
                    <div className={styles.subNavBackground}>
                        <div className={styles.subNavElements}>
                            <SubNavigationAside/>
                            <div className={styles.subNavContainer}>
                                <Button
                                    className={gcs(styles.navElementsCommon, styles.header)}
                                    type="secondary"
                                    renderAs="link"
                                    to={link?.url || externalUrl}
                                    icon="arrow-right"
                                >
                                    {activeLayerName}
                                </Button>
                                <div className={styles.subNavContainer}>
                                    {
                                        Object.keys(navMap).map((navElementId) => {
                                            const {id, subNavElements: navigationElements} =
                                                getNavElement(navElementId);

                                            if (navigationElements.length === 0) {
                                                return null;
                                            }

                                            return (
                                                <div
                                                    key={navElementId}
                                                    className={gcs(styles.subNavLinkContainer, [
                                                            id === activeId,
                                                            styles.active
                                                        ], [
                                                            id === activeId,
                                                            (isBackLink ? styles.transitionOut : styles.transitionIn)
                                                        ]
                                                    )}>
                                                    {navigationElements.map((navElementId) => {
                                                        const {
                                                            name,
                                                            subNavElements,
                                                            link,
                                                            externalUrl
                                                        } = getNavElement(navElementId);

                                                        let hasSubNavigation =
                                                            subNavElements.length > 0;

                                                        return (
                                                            <Button
                                                                className={
                                                                    styles.navElementsCommon
                                                                }
                                                                key={`btn-${navElementId}`}
                                                                type="secondary"
                                                                icon={
                                                                    hasSubNavigation
                                                                        ? "chevronRight"
                                                                        : ""
                                                                }
                                                                iconPosition={"right"}
                                                                renderAs={
                                                                    hasSubNavigation
                                                                        ? "button"
                                                                        : "link"
                                                                }
                                                                {...(hasSubNavigation
                                                                    ? {
                                                                        onClick: () => {
                                                                            dispatch({
                                                                                type: "navigate",
                                                                                to: navElementId
                                                                            })
                                                                            setIsBackLink(false)
                                                                        }
                                                                    }
                                                                    : {
                                                                        to:
                                                                            link?.url ||
                                                                            externalUrl
                                                                    })}
                                                            >
                                                                {name}
                                                            </Button>
                                                        );
                                                    })}
                                                </div>
                                            );

                                        })
                                    }
                                </div>
                                {!isMobile && (
                                    <Button
                                        className={styles.closeButton}
                                        type="secondary"
                                        icon="close"
                                        onClick={closeSubNav}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                newLocal && (
                    <div className={styles.subNavDecoration}>
                        <div className={styles.backgroundTest}/>
                        <button className={gcs(styles.blurredBackground, styles.active)} onMouseEnter={closeSubNav}/>
                    </div>
                )
            }
        </>
    );
}